<!-- c:\App\ERP\erp-system-venture-2020\src\app\smre-fee\smre-fee-report\smre-fee-report.component.html -->
<div class="report-container">
  <!-- Full page loading overlay for PDF export -->
  <div *ngIf="isExporting" class="full-page-overlay" data-html2canvas-ignore="true">
    <div class="spinner-large"></div>
    <h3 style="margin-top: 1rem; color: #1e293b;">Generating PDF...</h3>
  </div>

  <div class="header">
    <h2>SMRS Fee Report</h2>
    
    <div class="controls">
      <div class="period-select-wrapper">
        <label for="period-select" class="period-select-label">Select Period</label>
        <select id="period-select" [(ngModel)]="selectedPeriod" (ngModelChange)="onPeriodChange()" class="period-select">
          <option *ngFor="let p of periods" [value]="p">{{ p }}</option>
        </select>
      </div>
      <button class="action-btn view-btn open-pdf-btn" (click)="openPdf()" [disabled]="isExporting || gridData.length === 0">
        <div *ngIf="isExporting" class="spinner-in-btn"></div>
        <svg *ngIf="!isExporting" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
        {{ isExporting ? 'Generating...' : 'Export to PDF' }}
      </button>
    </div>
  </div>
  
  <p class="scope-note" data-testid="smrs-scope-note">Brand: <strong>{{ targetBrand }}</strong> &middot; Period: <strong>{{ selectedPeriod }}</strong></p>

  <div class="visible-report-content">

    <!-- KPIs for selected stores -->
    <div class="dashboard-container" *ngIf="gridData.length > 0">
      <div class="stat-card">
        <div class="stat-title">Total Revenue (USD)</div>
        <div class="stat-value">{{ kpiData.totalRevenue | currency }}</div>
      </div>
      <div class="stat-card" *ngFor="let rate of rateTypes">
        <div class="stat-title">{{ rate.name }} Fee (USD)</div>
        <div class="stat-value">{{ (kpiData[rate.id!] || 0) | currency }}</div>
      </div>
      <div class="stat-card total-kpi">
        <div class="stat-title">Total Fee (USD)</div>
        <div class="stat-value">{{ kpiData.total | currency }}</div>
      </div>
    </div>

    <!-- Incentives KPI -->
    <div class="incentives-container" *ngIf="!isLoading && incentiveStats.rateNames.length > 0">
      <h3 class="incentives-title">Fees Breakdown by Rate (USD)</h3>
      <div class="incentives-table-wrapper">
        <table class="incentives-table">
          <thead>
            <tr>
              <th></th>
              <th *ngFor="let name of incentiveStats.rateNames">{{ name }}</th>
              <th class="total-col-header">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="row-label">{{ partnerLabel }}</td>
              <td *ngFor="let name of incentiveStats.rateNames">{{ incentiveStats.lfc[name] | currency }} <span class="rate-percentage">({{ incentiveStats.lfcRates[name] }}%)</span></td>
              <td class="total-col">{{ incentiveStats.grandTotalLfc | currency }}</td>
            </tr>
            <tr>
              <td class="row-label">KCEG</td>
              <td *ngFor="let name of incentiveStats.rateNames">{{ incentiveStats.kceg[name] | currency }} <span class="rate-percentage">({{ incentiveStats.kcegRates[name] }}%)</span></td>
              <td class="total-col">{{ incentiveStats.grandTotalKceg | currency }}</td>
            </tr>
            <tr class="total-row-kpi">
              <td class="row-label">Total</td>
              <td *ngFor="let name of incentiveStats.rateNames">{{ incentiveStats.total[name] | currency }}</td>
              <td class="total-col">{{ incentiveStats.grandTotal | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Toolbar for filters -->
    <div class="toolbar-container" *ngIf="gridData.length > 0">
    <div class="filter-dropdown" [class.dropdown-active]="showCountryFilterDropdown">
      <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleCountryFilterDropdown()" [class.active]="showCountryFilterDropdown">
        <span>{{ filterCountry === 'All' ? 'All Countries' : filterCountry }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showCountryFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
      </button>
      <div class="dropdown-menu" *ngIf="showCountryFilterDropdown">
        <div class="dropdown-item" (click)="selectCountryFilter('All')">
          <span>All Countries</span>
        </div>
        <div class="dropdown-divider" *ngIf="availableCountries.length > 0"></div>
        <div class="dropdown-scroll">
          <div class="dropdown-item" *ngFor="let c of availableCountries" (click)="selectCountryFilter(c)">
            <span>{{ c }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-dropdown" [class.dropdown-active]="showCompanyFilter">
      <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleCompanyFilter()" [class.active]="showCompanyFilter" [disabled]="companiesForFilter.length === 0">
        <span>Select Companies ({{ selectedCompaniesCount }}/{{ companiesForFilter.length }})</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showCompanyFilter"><polyline points="6 9 12 15 18 9"></polyline></svg>
      </button>
      <div class="dropdown-menu" *ngIf="showCompanyFilter">
        <div class="dropdown-item" (click)="toggleAllCompanies()">
          <input type="checkbox" [checked]="selectedCompanies.size === allUniqueCompanies.length" (click)="$event.stopPropagation(); toggleAllCompanies()">
          <span>(Select All)</span>
        </div>
        <div class="dropdown-item" (click)="toggleKcegOwnedFilter()">
          <input type="checkbox" [checked]="isKcegOwnedSelected" (click)="$event.stopPropagation(); toggleKcegOwnedFilter()">
          <span>Select KCEG Owned</span>
        </div>
        <div class="dropdown-divider"></div>
        <div class="dropdown-scroll">
          <div class="dropdown-item" *ngFor="let c of companiesForFilter" (click)="toggleCompanySelection(c)">
            <input type="checkbox" [checked]="selectedCompanies.has(c)" (click)="$event.stopPropagation(); toggleCompanySelection(c)">
            <span>{{ c }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-dropdown" [class.dropdown-active]="showStoreFilter">
      <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleStoreFilter()" [class.active]="showStoreFilter" [disabled]="storesForFilter.length === 0">
        <span>Select Stores ({{ selectedStoresCount }}/{{ storesForFilter.length }})</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showStoreFilter"><polyline points="6 9 12 15 18 9"></polyline></svg>
      </button>
      <div class="dropdown-menu" *ngIf="showStoreFilter">
        <div class="dropdown-item" (click)="toggleAllStores()">
          <input type="checkbox" [checked]="selectedStores.size === allUniqueStores.length" (click)="$event.stopPropagation(); toggleAllStores()">
          <span>(Select All)</span>
        </div>
        <div class="dropdown-divider"></div>
        <div class="dropdown-scroll">
          <div class="dropdown-item" *ngFor="let s of storesForFilter" (click)="toggleStoreSelection(s)">
            <input type="checkbox" [checked]="selectedStores.has(s)" (click)="$event.stopPropagation(); toggleStoreSelection(s)">
            <span>{{ s }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Hidden PDF Template -->
  <div class="pdf-hidden-container">
    <div id="pdf-report-content" class="pdf-wrapper">
      
      <!-- Header -->
      <div class="card header-card">
        <div class="company-info">
          <h2>SMRS Fee Report - {{ targetBrand }}</h2>
        </div>
        <div class="date-info">
          <div class="info-item">
            <label>Statement Period</label>
            <span>{{ selectedPeriod }}</span>
          </div>
        </div>
      </div>

      <!-- Summary Cards (KPIs) -->
      <div class="summary-grid" *ngIf="gridData.length > 0">
        <div class="card summary-card">
          <label>Total Revenue (USD)</label>
          <span class="value">{{ kpiData.totalRevenue | currency }}</span>
        </div>
        <div class="card summary-card" *ngFor="let rate of rateTypes">
          <label>{{ rate.name }} Fee (USD)</label>
          <span class="value">{{ (kpiData[rate.id!] || 0) | currency }}</span>
        </div>
        <div class="card summary-card highlight">
          <label>Total Fee (USD)</label>
          <span class="value">{{ kpiData.total | currency }}</span>
        </div>
      </div>

      <!-- Incentives KPI -->
      <div class="card main-card" *ngIf="!isLoading && incentiveStats.rateNames.length > 0">
        <h3 class="section-title mt-0">Fees Breakdown by Rate (USD)</h3>
        <table class="data-table">
          <thead>
            <tr>
              <th>Category</th>
              <th *ngFor="let name of incentiveStats.rateNames" class="text-right">{{ name }}</th>
              <th class="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pdf-row">
              <td class="fw-500">{{ partnerLabel }}</td>
              <td *ngFor="let name of incentiveStats.rateNames" class="text-right">{{ incentiveStats.lfc[name] | currency }} <span class="rate-percentage">({{ incentiveStats.lfcRates[name] }}%)</span></td>
              <td class="text-right fw-600">{{ incentiveStats.grandTotalLfc | currency }}</td>
            </tr>
            <tr class="pdf-row">
              <td class="fw-500">KCEG</td>
              <td *ngFor="let name of incentiveStats.rateNames" class="text-right">{{ incentiveStats.kceg[name] | currency }} <span class="rate-percentage">({{ incentiveStats.kcegRates[name] }}%)</span></td>
              <td class="text-right fw-600">{{ incentiveStats.grandTotalKceg | currency }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="pdf-row">
              <th>Total</th>
              <th *ngFor="let name of incentiveStats.rateNames" class="text-right">{{ incentiveStats.total[name] | currency }}</th>
              <th class="text-right fee-col">{{ incentiveStats.grandTotal | currency }}</th>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="page-break-before" *ngIf="gridData.length > 0"></div>

      <!-- Main Grid -->
      <div class="card main-card" *ngIf="gridData.length > 0">
        <h3 class="section-title mt-0">Store Fee Details</h3>
        <div class="data-grid-scrollable"> <!-- Wrapper maintains TS logic compatibility -->
          <table class="data-table">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Store ID</th>
                <th>Country</th>
                <th class="text-right">Total Revenue (USD)</th>
                <th *ngFor="let rate of rateTypes" class="text-right">{{ rate.name }} ({{ rate.rate }}%) (USD)</th>
                <th class="text-right">Total Fee (USD)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filteredGridData" class="pdf-row">
                <td class="fw-500 text-dark">{{ row.companyName }}</td>
                <td>{{ row.id }}</td>
                <td>{{ row.country }}</td>
                <td class="text-right">{{ row.totalRevenue | currency }}</td>
                <td *ngFor="let rate of rateTypes" class="text-right">
                  {{ (row.rates[rate.id!] || 0) | currency }}
                </td>
                <td class="text-right fw-600">{{ row.total | currency }}</td>
              </tr>
              <tr *ngIf="filteredGridData.length === 0 && !isLoading">
                <td [attr.colspan]="6 + rateTypes.length" class="empty-table-msg">No data available for this period.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>

    <!-- Backdrop for closing filters -->
    <div class="filter-backdrop" *ngIf="showCompanyFilter || showStoreFilter || showCountryFilterDropdown" (click)="closeFilters()"></div>

    <div class="data-grid-container">
      <div *ngIf="isLoading" class="loading-overlay">
        <div class="spinner"></div>
      </div>

      <div class="data-grid-scrollable">
        <table class="data-grid">
          <thead>
            <tr>
              <th>Company Name</th>
              <th>Store ID</th>
              <th>Country</th>
              <th class="text-right">Total Revenue (USD)</th>
              <!-- Dynamic columns for each Rate Type -->
              <th *ngFor="let rate of rateTypes" class="text-right rate-col">{{ rate.name }} ({{ rate.rate }}%) (USD)</th>
              <th class="text-right">Total Fee (USD)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of filteredGridData">
              <td>{{ row.companyName }}</td>
              <td>{{ row.id }}</td>
              <td>{{ row.country }}</td>
              <td class="text-right">{{ row.totalRevenue | currency }}</td>
              <!-- Dynamic cells for each Rate Type -->
              <td *ngFor="let rate of rateTypes" class="text-right">
                {{ (row.rates[rate.id!] || 0) | currency }}
              </td>
              <td class="text-right font-bold">{{ row.total | currency }}</td>
            </tr>
            <tr *ngIf="filteredGridData.length === 0 && !isLoading">
              <td [attr.colspan]="6 + rateTypes.length" class="empty-state">
                <ng-container *ngIf="!loadError">No data available for this period.</ng-container>
                <ng-container *ngIf="loadError"><span data-testid="smrs-load-error">Failed to load the report. Please try again.</span></ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
